import React, { useEffect, useRef, useState } from 'react';

import { paths } from '@helpers/Constants';
import BrowserHistory from '@helpers/BrowserHistory';
import { Api } from '@apis/client';
import Http from '@helpers/Http';
import Filter from '@helpers/Filter';
import userStore from '@stores/user';
import FridayService from '@services/friday';

import './index.module.less';

import NavBar from '@components/NavBar';
import CommonBtn from '@components/CommonBtn';

import avatarIconUrl from '@images/avatar_normal.png';

const DeviceBindMember = () => {
  const params = useRef(Filter.urlParams(window.location.search));
  const [members, setMembers] = useState([]);

  const getInfo = async () => {
    const { data } = await Http.post(Api.GetDeviceDetailInfo, {
      snCode: params.current.sncode,
      company: 'lingge',
    });
    setMembers(data?.users || []);
  };

  const toDetailPage = () => {
    FridayService.addEvent('device_information_binding_parent_add_member_click');
    BrowserHistory.push(
      `${PUBLIC_URL}${paths.deviceQrcodeInfo}?sncode=${params.current.sncode}`,
    );
  };

  useEffect(() => {
    getInfo();
  }, []);

  const renderMembers = () => {
    let Items = null;
    if (members?.length) {
      Items = members.map(item => {
        return (
          <div className="flex" styleName="list-item">
            <img
              styleName="item-img"
              src={item.headImageUrl || avatarIconUrl}
              alt=""
            />
            <div className="flex" styleName="item-info">
              <div className="flex" styleName="item-info-desc">
                <div
                  styleName="item-name"
                  className="els"
                  style={{
                    maxWidth:
                      item.isAdmin || item.userUid === userStore.userInfo.uid
                        ? '3rem'
                        : '5rem',
                  }}
                >
                  {item.name || '未命名'}
                </div>
                {item.isAdmin ? (
                  <span styleName="item-label">管理员</span>
                ) : null}
                {item.userUid === userStore.userInfo.uid ? (
                  <span styleName="item-tag">自己</span>
                ) : null}
              </div>
              <div styleName="item-phone">
                {Filter.transformPhone(item.phone)}
              </div>
            </div>
          </div>
        );
      });
    }
    return Items;
  };

  return (
    <div className="flex container" styleName="container">
      <NavBar title={`绑定成员（${members?.length || 0}）`} />
      <div styleName="content">
        <div styleName="top-tips">
          以下成员可以设置学生证。仅设备管理员可以同意他人绑定、解绑设备。
        </div>
        <div className="flex" styleName="list-wrapper">
          {renderMembers()}
        </div>
      </div>

      <CommonBtn
        type="fixed"
        btnText="添加成员"
        onConfirm={toDetailPage}
        disabled={members?.length >= 10}
      />
    </div>
  );
};

export default DeviceBindMember;
